import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  { path: 'purchase', redirectTo: 'purchase/list', pathMatch: 'full' },
  {
    path: 'purchase',
    children: [
      {
        path: 'list',
        loadComponent: () => import('./licenses.component').then((m) => m.LicensesComponent),
      }
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class licensesRoutingModule {
  static routes = admin;
}
